import React from "react";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";


import { AppConfig } from "./Config";

import "semantic-ui-css/semantic.min.css";
import { ToastProvider } from "react-toast-notifications";

import store from "./store";
import routes from "./routes/index";
import './i18n';

if (AppConfig.environment !== "Development") {
  Sentry.init({
    dsn: AppConfig.sentryDSN,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
  });
}

function App() {
  const routing = useRoutes(routes);
  return (
    <Provider store={store}>
      <ToastProvider>
      {routing}
      </ToastProvider>
    </Provider>
  );
}

export default App;

